import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionCreators from '../redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";

function* getCharacterDetail({params}) {
  try {
    const response = yield call(() =>
      API.get(ROUTES.API_CHARACTER+'/'+params.id, {params} )
    );
    yield put(actionCreators.getCharacterDetailSuccess(response.data.data));

  } catch (error) {
    
  }
}

function* characterDetail() {
  yield takeLatest(actionTypes.GET_CHARACTER_DETAIL_REQUEST, getCharacterDetail);
}

export default characterDetail;
